/** Detecta la plataforma del dispositiu */
function plataforma() {
  const ua = navigator.userAgent.toLowerCase()
  if (/iphone|ipad|ipod/.test(ua)) return 'ios'
  if (/android/.test(ua))          return 'android'
  return 'web'
}

// Deep links per app i plataforma
const LINKS = {
  'google-maps': {
    ios:     (lat, lng) => `comgooglemaps://?daddr=${lat},${lng}&directionsmode=driving`,
    android: (lat, lng) => `google.navigation:q=${lat},${lng}&mode=d`,
    web:     (lat, lng) => `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&travelmode=driving`,
  },
  'apple-maps': {
    ios:     (lat, lng) => `maps://?daddr=${lat},${lng}&dirflg=d`,
    android: null, // no existeix
    web:     (lat, lng) => `https://maps.apple.com/?daddr=${lat},${lng}&dirflg=d`,
  },
  uber: {
    ios:     (lat, lng, dest) => `uber://?action=setPickup&pickup=my_location&dropoff[latitude]=${lat}&dropoff[longitude]=${lng}&dropoff[nickname]=${dest}`,
    android: (lat, lng, dest) => `uber://?action=setPickup&pickup=my_location&dropoff[latitude]=${lat}&dropoff[longitude]=${lng}&dropoff[nickname]=${dest}`,
    web:     (lat, lng, dest) => `https://m.uber.com/ul/?action=setPickup&pickup=my_location&dropoff[latitude]=${lat}&dropoff[longitude]=${lng}&dropoff[nickname]=${dest}`,
  },
  bolt: {
    ios:     ()          => `bolt://`,
    android: ()          => `bolt://`,
    web:     (lat, lng)  => `https://bolt.eu/ca/cities/barcelona/`,
  },
}

/**
 * Obre una app de navegació o taxi amb deep link.
 * En dispositiu mòbil, intenta el deep link i fa fallback a web si no s'obre.
 *
 * @param {number} lat
 * @param {number} lng
 * @param {string} adreca   - Etiqueta llegible per al destí
 * @param {'bolt'|'uber'|'google-maps'|'apple-maps'} app
 */
export function openNavigationApp(lat, lng, adreca = '', app) {
  const plat = plataforma()
  const dest = encodeURIComponent(adreca || `${lat},${lng}`)

  // 'auto' → Apple Maps a iOS, Google Maps a la resta
  const resolvedApp = app === 'auto' ? (plat === 'ios' ? 'apple-maps' : 'google-maps') : app

  const config = LINKS[resolvedApp]
  if (!config) throw new Error(`App desconeguda: ${resolvedApp}`)

  // Apple Maps no existeix a Android → fallback Google Maps web
  if (!config[plat]) {
    window.open(LINKS['google-maps'].web(lat, lng), '_blank')
    return
  }

  const deepLink = config[plat](lat, lng, dest)
  const webLink  = config.web(lat, lng, dest)

  if (plat !== 'web' && deepLink !== webLink) {
    // Fallback a web si l'app no s'obre en 1.5 s
    const fallback = setTimeout(() => window.open(webLink, '_blank'), 1500)
    window.addEventListener('blur', () => clearTimeout(fallback), { once: true })
    window.location.href = deepLink
  } else {
    window.open(deepLink, '_blank')
  }
}

/**
 * Retorna les opcions de transport per mostrar al modal selector.
 * Filtra Apple Maps si no és iOS.
 *
 * @param {number} lat
 * @param {number} lng
 * @param {string} adreca
 * @returns {{ id, label, emoji, onPress }[]}
 */
export function showAppSelector(lat, lng, adreca = '') {
  const plat = plataforma()

  const opcions = [
    { id: 'google-maps', label: 'Google Maps', emoji: '🗺️', show: true },
    { id: 'apple-maps',  label: 'Apple Maps',  emoji: '🍎', show: plat === 'ios' },
    { id: 'uber',        label: 'Uber',         emoji: '⚫', show: true },
    { id: 'bolt',        label: 'Bolt',         emoji: '⚡', show: true },
  ]

  return opcions
    .filter(o => o.show)
    .map(({ id, label, emoji }) => ({
      id,
      label,
      emoji,
      onPress: () => openNavigationApp(lat, lng, adreca, id),
    }))
}
